import React, { useState, useEffect } from "react";
import userApi, { getUserReviews } from "../../HTTP/user"
import ReviewBlocks from '../Review/ReviewBlocks'; // Assurez-vous que le chemin d'importation est correct
import { deleteReview, getArticles, getArticlesByAuthorId, getUserReviewsPaginated } from "../../HTTP/articles"
import "../Home/Home.css";
import "../Home/articles.css";
import SearchIcon from "@mui/icons-material/Search";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import imgArticle from "../../media/ICONS THEMATIQUE/Fichier 5_1.png"
import { addFavorite, getFeedArticles, getFeedReviews, getFriendsArticles, getFriendsReviews, getOriginArticleFromLink, removeFavorite } from "../../HTTP/articles";
import { formatDateExtended, goToStaticPage, removeHtmlTags } from "../../Helper/utils";
import Pagination from "../../Helper/Pagination";
import { getUserCountry } from "../../HTTP/countries";
import { sendArticleReadNotification } from "../../HTTP/user";
import RecommendToFriendPopup from "../Common/RecommendToFriendPopup";
import { getIgo } from "../../HTTP/translation";
import useCurrentLanguage from "../../Helper/useCurrentLanguage";
import { countries } from "../../global/countriesAndSources";
import ProfileFeedSection from "../Profile/ProfileFeedSection";
import { PUBLISHED_VISIBILITY_OPTIONS } from "../../Helper/visibilityOptions";
import IgoFavoritesButton from "../Common/IgoFavoritesButton";


export const Reviews = () => {
	const user = JSON.parse(localStorage.getItem("user"));
	const currentLanguage = useCurrentLanguage();
	const isFrenchLanguage = currentLanguage.startsWith("fr");
	const url = new URL(window.location.href)
	if (url.searchParams.get('articlepage') === null) {
		url.searchParams.set('articlepage', 1);
		window.history.pushState({}, '', url);
	}
	if (url.searchParams.get('reviewpage') === null) {
		url.searchParams.set('reviewpage', 1);
		window.history.pushState({}, '', url);
	}
	const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
	const [launchSearch, setLaunchSearch] = useState(false);
	const [reviewDeleted, setReviewDeleted] = useState(false);
	const [currentArticlePage, setCurrentArticlePage] = useState(parseInt(url.searchParams.get('articlepage')));
	const [currentReviewPage, setCurrentReviewPage] = useState(parseInt(url.searchParams.get('reviewpage')));
	const [articlesPerPage] = useState(4);
	const [reviewsPerPage] = useState(3);
	const [articles, setArticles] = useState({ count: 0, rows: [] });
	const [articleReady, setArticleReady] = useState(false);
	const [reviews, setReviews] = useState({ count: 0, rows: [] });
	const [reviewsReady, setReviewsReady] = useState(false);
	const [activeSection, setActiveSection] = useState("favorites");
	const [selectedArticleIdForRecommendation, setSelectedArticleIdForRecommendation] = useState(null);
	const isUserSubscribed = JSON.parse(localStorage.getItem("subscriptions")) !== null
	const [sortBy] = useState(url.searchParams.get('sortby') === null ? 'title' : url.searchParams.get('sortby'))
	const [articleVisible, setArticleVisible] = useState(Number(url.searchParams.get('articleVisible') ?? 1));
	const [reviewVisible, setReviewVisible] = useState(Number(url.searchParams.get('reviewVisible') ?? 1));
	const [allIgo, setAllIgo] = useState([]);
	const [userIgoIds, setUserIgoIds] = useState(new Set());
	const [userIgoPrivacy, setUserIgoPrivacy] = useState({});
	const [igoLoading, setIgoLoading] = useState(false);
	const [followBusy, setFollowBusy] = useState({});
	const [privacyBusy, setPrivacyBusy] = useState({});

	const handleIgo = (igoElement) => {
		sessionStorage.setItem("search_igo", igoElement.name);
		const formattedLink = igoElement.link
			.replace(/^(https?:\/\/)?(www\.)?/, "")
			.replace(/\/$/, "");
		sessionStorage.setItem("search_query", formattedLink + " ");
		sessionStorage.setItem(
			"search_country",
			JSON.stringify(countries.find((c) => c.code === "wd"))
		);
		window.location.href = "/?igo=" + igoElement.name;
	};

	useEffect(() => {
		setArticleReady(false)
		const funArticles = async () => {
			const resArticles = await getArticlesByAuthorId(
				user.id,
				(currentArticlePage - 1) * articlesPerPage,
				currentArticlePage * articlesPerPage,
				articleVisible,
				searchTerm
			);
			setArticles(resArticles)
		}
		setReviewsReady(false)
		const funReviews = async () => {
			const resReviews = await getUserReviewsPaginated(
				user.id,
				(currentReviewPage - 1) * reviewsPerPage,
				currentReviewPage * reviewsPerPage,
				reviewVisible,
				searchTerm
			)
			setReviews(resReviews)
		}
		funArticles()
		funReviews()
		setArticleReady(true)
		setReviewsReady(true)
		setLaunchSearch(false)
		setReviewDeleted(false)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentArticlePage, currentReviewPage, launchSearch, articlesPerPage, reviewsPerPage, isUserSubscribed, user.id, reviewDeleted, articleVisible, reviewVisible]);

	const normalizeIgoIds = (res) => {
		const list = Array.isArray(res)
			? res
			: Array.isArray(res?.data)
				? res.data
				: Array.isArray(res?.items)
					? res.items
					: typeof res?.igo_id_list === "string"
						? res.igo_id_list.split(",").map((entry) => entry.trim())
						: [];

		return new Set(
			list
				.map((item) => item?.igo_id ?? item?.igoId ?? item?.id ?? item?.igo?.id ?? item)
				.filter(Boolean)
				.map((value) => String(value))
		);
	};

	const normalizeIgoPrivacy = (res) => {
		const list = Array.isArray(res)
			? res
			: Array.isArray(res?.data)
				? res.data
				: Array.isArray(res?.items)
					? res.items
					: typeof res?.igo_id_list === "string"
						? res.igo_id_list.split(",").map((entry) => entry.trim())
						: [];

		return list.reduce((acc, item) => {
			const igoId = item?.igo_id ?? item?.igoId ?? item?.id ?? item?.igo?.id;
			if (!igoId) return acc;
			const privateState = item?.followed_private ?? item?.private ?? item?.is_private ?? item?.private_status ?? 0;
			acc[String(igoId)] = Number(privateState) === 1;
			return acc;
		}, {});
	};

	const loadIgoData = async () => {
		setIgoLoading(true);
		try {
			const [igoList, userIgoRes] = await Promise.all([
				getIgo(),
				userApi.getIgoFromUser(user.id),
			]);
			setAllIgo(Array.isArray(igoList) ? igoList : []);
			setUserIgoIds(normalizeIgoIds(userIgoRes));
			setUserIgoPrivacy(normalizeIgoPrivacy(userIgoRes));
		} catch (err) {
			console.error("Erreur lors du chargement des OIG", err);
			setAllIgo([]);
			setUserIgoIds(new Set());
			setUserIgoPrivacy({});
		} finally {
			setIgoLoading(false);
		}
	};

	useEffect(() => {
		let alive = true;
		const fetchData = async () => {
			if (!alive) return;
			await loadIgoData();
		};

		fetchData();
		return () => {
			alive = false;
		};
	}, [user.id]);

	const handleSearch = (e) => {
		e.preventDefault();
		const nextUrl = new URL(window.location.href);
		nextUrl.searchParams.set('articlepage', 1);
		nextUrl.searchParams.set('reviewpage', 1);
		nextUrl.searchParams.set('articleVisible', articleVisible);
		nextUrl.searchParams.set('reviewVisible', reviewVisible);
		if (searchTerm) {
			nextUrl.searchParams.set('query', searchTerm);
		} else {
			nextUrl.searchParams.delete('query');
		}
		window.history.pushState({}, '', nextUrl);
		setLaunchSearch(true);
	};

	const articlePaginate = (pageNumber) => {
		const nextUrl = new URL(window.location.href);
		nextUrl.searchParams.set('articlepage', pageNumber);
		nextUrl.searchParams.set('articleVisible', articleVisible);
		nextUrl.searchParams.set('reviewVisible', reviewVisible);
		window.history.pushState({}, '', nextUrl);
		setCurrentArticlePage(pageNumber);
	};

	const reviewPaginate = (pageNumber) => {
		const nextUrl = new URL(window.location.href);
		nextUrl.searchParams.set('reviewpage', pageNumber);
		nextUrl.searchParams.set('articleVisible', articleVisible);
		nextUrl.searchParams.set('reviewVisible', reviewVisible);
		window.history.pushState({}, '', nextUrl);
		setCurrentReviewPage(pageNumber);
	};

	const handleViewArticle = (id) => {
		goToStaticPage(true, id);
	}

	const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem('favorites') || []));

	const handleArticleToFavorite = async (title, link, image, country, date, description) => {
		const countryFromFavorite = await getOriginArticleFromLink(link);
		const favorite = {
			title: title,
			link: link,
			image: image || "",
			country: countryFromFavorite.country || country,
			publication_date: date,
			description: description
		};

		try {
			const res = await addFavorite(favorite);
			if (res.ok === true) {
				favorite.id = res.id;
				const updatedFavorites = [favorite, ...favorites];
				setFavorites(updatedFavorites);
				localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
				alert('Article added to favorites !');
			}
		} catch (error) {
			console.error('An error has occured when adding the favorite', error);
			alert('An error has occured when adding the favorite');
		}
	};

	const handleRemoveFromFavorite = async (link) => {
		try {
			const res = await removeFavorite({ link });
			if (res) {
				console.log(favorites)
				const updatedFavorites = favorites.filter(fav => fav.link !== link);
				console.log(updatedFavorites)
				setFavorites(updatedFavorites);
				localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
				alert('Article removed from favorites !');
			}
		} catch (error) {
			console.error('An error has occured when deleting the favorite', error);
			alert('An error has occured when deleting the favorite');
		}
	};

	const handleDeleteReview = async (reviewId) => {
		if (window.confirm("Are you sure you want to delete this review?")) {
			try {
				const res = await deleteReview(reviewId);
				if (res) {
					setReviewDeleted(true);
					alert("Review deleted successfully");
				}
			} catch (error) {
				console.error("An error occurred while deleting the review", error);
				alert("An error occurred while deleting the review");
			}
		}
	};

	const handleSendArticleNotification = async (friendId) => {
		if (!selectedArticleIdForRecommendation || !friendId) return false;
		const res = await sendArticleReadNotification(selectedArticleIdForRecommendation, friendId);
		if (res) {
			alert("Notification envoyee");
			return true;
		}
		alert("Erreur lors de l'envoi de la notification");
		return false;
	};

	const userIgoList = allIgo
		.filter((item) => userIgoIds.has(String(item.id ?? item.igo_id ?? item.igoId)))
		.map((item) => {
			const igoId = item.id ?? item.igo_id ?? item.igoId;
			const backendPrivateFlag = item?.followed_private ?? item?.private ?? item?.is_private ?? item?.private_status ?? 0;
			return {
				...item,
				private: Boolean(userIgoPrivacy[String(igoId)] ?? Number(backendPrivateFlag) === 1),
			};
		});

	const isFollowingIgo = (igoId) => userIgoIds.has(String(igoId));
	const isIgoPrivate = (igoId) => Boolean(userIgoPrivacy[String(igoId)]);

	const toggleFollowIgo = async (igoId, shouldFollow) => {
		if (!user?.id || !igoId) return;
		const normalizedId = String(igoId);
		setFollowBusy((prev) => ({ ...prev, [normalizedId]: true }));
		try {
			const ok = shouldFollow
				? await userApi.addIgoToUser(user.id, igoId, isIgoPrivate(igoId))
				: await userApi.deleteIgoFromUser(user.id, igoId);
			if (!ok) return;
			await loadIgoData();
		} catch (err) {
			console.error("Erreur lors du suivi de l'OIG", err);
		} finally {
			setFollowBusy((prev) => ({ ...prev, [normalizedId]: false }));
		}
	};

	const toggleIgoPrivacy = async (igoId, shouldBePrivate) => {
		if (!user?.id || !igoId) return;
		const normalizedId = String(igoId);
		setPrivacyBusy((prev) => ({ ...prev, [normalizedId]: true }));
		try {
			const ok = await userApi.setIgoPrivate(user.id, igoId, shouldBePrivate);
			if (!ok) return;
			await loadIgoData();
		} catch (err) {
			console.error("Erreur lors du changement de visibilité de l'OIG", err);
		} finally {
			setPrivacyBusy((prev) => ({ ...prev, [normalizedId]: false }));
		}
	};

	const toggleAllIgoPrivacy = async (shouldBePrivate) => {
		if (!user?.id || userIgoIds.size === 0) return;
		try {
			const ok = await userApi.setAllIgoPrivate(user.id, shouldBePrivate);
			if (!ok) return;
			await loadIgoData();
		} catch (err) {
			console.error("Erreur lors de la mise à jour de la visibilité des OIG", err);
		}
	};

	const ArticleCard = ({ articleId, imageUrl, author, authorProfilePicture, authorId, title, text, date }) => {
		const articleLink = `https://static.zemus.info/article/?id=${articleId}&readerid=${user.id}`;
		const isFavorite = favorites.some(fav => fav.link === articleLink);

		const handleFavoriteClick = async () => {
			const authorCountry = await getUserCountry(authorId);
			if (isFavorite) {
				handleRemoveFromFavorite(articleLink);
			} else {
				handleArticleToFavorite(
					title,
					articleLink,
					imageUrl,
					authorCountry.country || user.country,
					new Date().toISOString().replace("T", " ").slice(0, 19),
					text.length > 150 ? text.slice(0, 50) + "..." : text
				);
			}
		};

		return (
			<div className="bg-white rounded-lg shadow-md overflow-hidden transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl h-full">
				<div className="flex flex-col h-full">
					<button onClick={() => handleViewArticle(articleId)}>
						<img
							className="w-full h-48 object-cover flex-shrink-0"
							src={imageUrl === null ? imgArticle : imageUrl}
							alt={title}
						/>
					</button>
					<div className="p-4 flex-grow flex flex-col">
						<button onClick={() => handleViewArticle(articleId)} className="flex-grow">
							<h3 className="text-lg font-semibold mb-2">{title}</h3>
							<p className="text-gray-600 flex-grow">
								{text.length > 150 ? text.slice(0, 50) + "..." : text}
							</p>
						</button>
						<div className="flex items-center mb-2">
							<p className="text-sm mt-2 ml-2 notranslate">
								{formatDateExtended(date)}
							</p>
							<button
								type="button"
								onClick={() => setSelectedArticleIdForRecommendation(articleId)}
								className="ml-auto focus:outline-none"
							>
								<ArrowOutwardIcon />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	};

	console.log(articles)
	console.log(reviews)

	return (
		<div className={`mt-8 ${isFrenchLanguage ? "notranslate" : ""}`} translate={isFrenchLanguage ? "no" : undefined}>
			<form onSubmit={handleSearch} className="flex w-full items-center mb-4">
				<div className="flex-grow ml-4 mr-2 mt-3">
					<input
						type="text"
						placeholder="Rechercher..."
						className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
					/>
				</div>
				<button
					type="submit"
					className="bg-zemusbis hover:bg-zemushover text-white font-bold mt-3 mr-4 py-2 px-4 rounded-md whitespace-nowrap"
				>
					<SearchIcon />
				</button>
			</form>
			<div className="w-full flex justify-center flex-row p-2">
				<button
					type="button"
					style={{ backgroundColor: activeSection === "favorites" ? '#c3e5ef' : "#009aad", color: activeSection === "favorites" ? "black" : "white" }}
					className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded mr-1"
					onClick={() => setActiveSection("favorites")}
				>
					Favoris partagés
				</button>
				<button
					type="button"
					style={{ backgroundColor: activeSection === "articles" ? '#c3e5ef' : "#009aad", color: activeSection === "articles" ? "black" : "white" }}
					className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded mr-1"
					onClick={() => setActiveSection("articles")}
				>
					Articles publiés
				</button>
				<button
					type="button"
					style={{ backgroundColor: activeSection === "igo" ? '#c3e5ef' : "#009aad", color: activeSection === "igo" ? "black" : "white" }}
					className="w-full mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded"
					onClick={() => setActiveSection("igo")}
				>
					Forums Globaux
				</button>
				<button
					type="button"
					style={{ backgroundColor: activeSection === "profile_feed" ? '#c3e5ef' : "#009aad", color: activeSection === "profile_feed" ? "black" : "white" }}
					className="w-full mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded ml-1"
					onClick={() => setActiveSection("profile_feed")}
				>
					Ma sélection
				</button>
			</div>
			{
				activeSection === "articles" && (
					<>
						<div className="flex justify-center text-center mb-4">
							<h2 className="text-2xl font-bold">{isUserSubscribed ? "Derniers articles publiés" : "Derniers articles publiés par mes amis"}</h2>
						</div>
						<div className="flex mb-4 ml-4">
							<select
								value={articleVisible}
								onChange={(e) => {
									const nextValue = Number(e.target.value);
									setArticleVisible(nextValue);
									const nextUrl = new URL(window.location.href);
									nextUrl.searchParams.set('articlepage', 1);
									nextUrl.searchParams.set('articleVisible', nextValue);
									nextUrl.searchParams.set('reviewVisible', reviewVisible);
									window.history.pushState({}, '', nextUrl);
								}}
								className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
							>
								{PUBLISHED_VISIBILITY_OPTIONS.map((option) => (
									<option value={option.value} key={option.value}>{option.label}</option>
								))}
							</select>
						</div>
						{
							articleReady && articles.count === 0 && (
								<div className="flex justify-center text-center mb-4">
									<h2 className="text-2xl font-bold">Aucun article trouvé</h2>
								</div>
							)
						}
						<div className="max-h-[50vh] overflow-y-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ml-4 mr-4">
							{
								articleReady && articles.count > 0 && articles.rows.map((item, index) => (
									<ArticleCard
										articleId={item.id}
										imageUrl={item.featured_image}
										author={item.firstname + " " + item.lastname}
										authorProfilePicture={item.profile_picture}
										authorId={item.user_id}
										title={item.title}
										text={removeHtmlTags(item.description)}
										date={item.updated_at}
									/>
								))
							}
						</div>
						<Pagination
							itemsPerPage={articlesPerPage}
							totalItems={articles.count}
							paginate={articlePaginate}
							currentPage={currentArticlePage}
						/>
					</>
				)
			}
			{
				activeSection === "favorites" && (
					<>
						<div className="flex justify-center text-center mb-4">
							<h2 className="mt-2 text-2xl font-bold">{isUserSubscribed ? "Dernières revues de presse publiées" : "Dernières revues de presse publiées par mes amis"}</h2>
						</div>
						<div className="flex mb-4 ml-4">
							<select
								value={reviewVisible}
								onChange={(e) => {
									const nextValue = Number(e.target.value);
									setReviewVisible(nextValue);
									const nextUrl = new URL(window.location.href);
									nextUrl.searchParams.set('reviewpage', 1);
									nextUrl.searchParams.set('reviewVisible', nextValue);
									nextUrl.searchParams.set('articleVisible', articleVisible);
									window.history.pushState({}, '', nextUrl);
								}}
								className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
							>
								{PUBLISHED_VISIBILITY_OPTIONS.map((option) => (
									<option value={option.value} key={option.value}>{option.label}</option>
								))}
							</select>
						</div>
						<div className="max-h-[50vh] overflow-y-auto ml-4 mr-4 mb-8">
							{
								reviewsReady && reviews.count === 0 && (
									<div className="flex justify-center text-center mb-4">
										<h2 className="text-2xl font-bold">Aucune revue de presse trouvée</h2>
									</div>
								)
							}
							{
								reviewsReady && reviews.count > 0 &&
								<ReviewBlocks reviews={reviews.rows} onDeleteReview={handleDeleteReview} edition="true" displayAuthor={false} favorites={favorites} handleAddFav={handleArticleToFavorite} handleRemFav={handleRemoveFromFavorite} />
							}
						</div>

						<Pagination
							itemsPerPage={reviewsPerPage}
							totalItems={reviews.count}
							paginate={reviewPaginate}
							currentPage={currentReviewPage}
						/>
					</>
				)
			}
			{
				activeSection === "igo" && (
					<div className="profileContainer">
						<div className="flex justify-center text-center mb-4">
							<h2 className="mt-2 text-2xl font-bold">Forums Globaux</h2>
						</div>
						{userIgoList.length > 0 && (
							<div className="flex justify-end gap-2 mr-4 mb-4">
								<button
									type="button"
									className="border border-cyan-700 text-cyan-700 px-3 py-2 rounded text-sm"
									onClick={() => toggleAllIgoPrivacy(false)}
								>
									Rendre publics tous
								</button>
								<button
									type="button"
									className="border border-red-500 text-red-600 px-3 py-2 rounded text-sm"
									onClick={() => toggleAllIgoPrivacy(true)}
								>
									Tout mettre en privé
								</button>
							</div>
						)}
						{igoLoading ? (
							<p className="ml-4 mb-4">Chargement des Forums Globaux…</p>
						) : userIgoList.length === 0 ? (
							<div className="flex justify-center text-center mb-4">
								<h2 className="text-2xl font-bold">Aucun Forum global suivi pour le moment</h2>
							</div>
						) : (
							<div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 ml-4 mr-4 mb-4">
								{userIgoList.map((igoItem) => {
									const igoId = igoItem.id ?? igoItem.igo_id ?? igoItem.igoId;
									const isPrivate = Boolean(igoItem.private);
									return (
										<div key={igoId} className="bg-white rounded-lg shadow p-4">
										<div className="flex items-center gap-3">
											<img
												className="w-12 h-12 mr-3 object-contain"
												src={igoItem.image || process.env.PUBLIC_URL + "/favicon.png"}
												alt={igoItem.label || igoItem.name}
											/>
											<div className="flex-1">
												<button onClick={() => handleIgo(igoItem)} className="font-semibold">{igoItem.label || igoItem.name}</button>
												<div className="mt-2 text-xs text-gray-600">
													{isPrivate ? "Privé" : "Public"}
												</div>
											</div>
											<div className="flex flex-col gap-2">
												{igoId && (
													<button
														type="button"
														className={
															isFollowingIgo(igoId)
																? "border-2 border-red-500 text-red-600 px-3 py-1 rounded text-sm"
																: "border-2 border-cyan-600 text-cyan-700 px-3 py-1 rounded text-sm"
														}
														disabled={followBusy[String(igoId)]}
														onClick={() => toggleFollowIgo(igoId, !isFollowingIgo(igoId))}
													>
														{isFollowingIgo(igoId) ? "Ne plus suivre" : "Suivre"}
													</button>
												)}
												{igoId && (
													<button
														type="button"
														className={
															isPrivate
																? "border-2 border-cyan-600 text-cyan-700 px-3 py-1 rounded text-sm"
																: "border-2 border-gray-400 text-gray-700 px-3 py-1 rounded text-sm"
														}
														disabled={privacyBusy[String(igoId)]}
														onClick={() => toggleIgoPrivacy(igoId, !isPrivate)}
													>
														{isPrivate ? "Rendre public" : "Mettre en privé"}
													</button>
												)}
											</div>
										</div>
										{igoId && (
											<div className="mt-3">
												<IgoFavoritesButton igoId={igoId} igoName={igoItem.label || igoItem.name} />
											</div>
										)}
										</div>
									);
								})}
							</div>
						)}
					</div>
				)
			}
			{
				activeSection === "profile_feed" && (
					<ProfileFeedSection
						profileUserId={user.id}
						currentUserId={user.id}
						canView={true}
						canPost={true}
						scrollable
						title="Ma sélection"
					/>
				)
			}
			<RecommendToFriendPopup
				isOpen={selectedArticleIdForRecommendation !== null}
				onClose={() => setSelectedArticleIdForRecommendation(null)}
				onConfirm={handleSendArticleNotification}
				title="Recommander à un ami"
			/>

		</div>
	);
}
